export default {
  sidebar: null,
};
